import { InfracaoSearch } from './infracao.search';
import { LoaderService } from '../loader.service';
import { InfracaoController } from "app/controllers/mob/infracao.controller";
import { Injectable } from '@angular/core';
import { Infracao } from '@tivic-team/manager-ts/dist/mob';

@Injectable()
export class InfracaoService {

    constructor (
        private _infracaoController: InfracaoController,
        private _loaderService: LoaderService
    ) {}

    async find(infracaoSearch?: InfracaoSearch, isLoading: boolean = true) {
        try {
            if(isLoading)
                this._loaderService.show();
            
            return await this._infracaoController.find(infracaoSearch && infracaoSearch.getFilters() || null ).finally(() => {
                if( isLoading )
                    this._loaderService.hide();
            });
        } catch(error) {
            console.log(error);
            return [];
        }
    }

    async get(cdInfracao:number):Promise<Infracao> {
        this._loaderService.show();
        return this._infracaoController.get(cdInfracao).finally(() => {
            this._loaderService.hide();
        });
    }

    async save(infracao:Infracao):Promise<Infracao>{
        this._loaderService.show();
        if(infracao.cdInfracao && infracao.cdInfracao > 0)
            return this._infracaoController.update(infracao).finally(() => this._loaderService.hide());
        else
            return this._infracaoController.create(infracao).finally(() => this._loaderService.hide());
    }

}